module.exports = __webpack_public_path__ + "static/media/developerActivity.c86df7dd.svg";